export default {
  text: '#85723e',
  primary: '#d3b973',
  secondary: '#202020',
  background: 'white',
  backgroundSecondary: 'black',
  light: '#FFF',
  dark: '#202020'
}
